<template>
  <div class="content">
    <!-- Виджет статуса участника -->
    <div class="status-widget" :class="`status-widget--${form.status}`">
      <span>{{ getStatusLabel(form.status) }}</span>
    </div>

    <div class="content__title content__title--party">
      <div class="content__title content__title--party content__title--start">
        <router-link
          :to="{ name: 'journal-list' }"
          class="button button--light button--no-indent button--small"
        >
          <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.70917 13.7082C7.61629 13.8013 7.50595 13.8752 7.38447 13.9256C7.263 13.976 7.13277 14.002 7.00125 14.002C6.86973 14.002 6.7395 13.976 6.61802 13.9256C6.49655 13.8752 6.38621 13.8013 6.29332 13.7082L0.293962 7.70884C0.200846 7.61595 0.126968 7.50562 0.0765611 7.38414C0.0261537 7.26266 0.000206594 7.13243 0.000206606 7.00091C0.000206617 6.86939 0.0261537 6.73916 0.0765611 6.61769C0.126969 6.49621 0.200846 6.38587 0.293962 6.29299L6.29333 0.293626C6.48108 0.105873 6.73573 0.00039471 7.00125 0.000394734C7.26677 0.000394757 7.52142 0.105873 7.70918 0.293626C7.89693 0.481379 8.00241 0.736028 8.00241 1.00155C8.00241 1.26707 7.89693 1.52172 7.70917 1.70948L2.41574 7.00091L7.70917 12.2923C7.80229 12.3852 7.87617 12.4956 7.92658 12.617C7.97698 12.7385 8.00293 12.8688 8.00293 13.0003C8.00293 13.1318 7.97698 13.262 7.92658 13.3835C7.87617 13.505 7.80229 13.6153 7.70917 13.7082Z"
                fill="#2B93E7"/>
            <path d="M16 7.00108C16 7.26627 15.8947 7.5206 15.7071 7.70811C15.5196 7.89563 15.2653 8.00098 15.0001 8.00098L2.00149 8.00098C1.7363 8.00098 1.48197 7.89563 1.29445 7.70811C1.10694 7.5206 1.00159 7.26627 1.00159 7.00108C1.00159 6.73589 1.10694 6.48156 1.29445 6.29405C1.48197 6.10653 1.7363 6.00119 2.00149 6.00119L15.0001 6.00119C15.2653 6.00119 15.5196 6.10653 15.7071 6.29405C15.8947 6.48157 16 6.73589 16 7.00108Z"
                  fill="#2B93E7"/>
          </svg>
        </router-link>
        <h1 class="title title--big title--theme">Редактирование члена РСМ</h1>
      </div>
      <button v-if="userRole === 'admin'" @click="openSidebar" class="link" type="button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 17.0134L11.413 16.9984L21.045 7.45839C21.423 7.08039 21.631 6.57839 21.631 6.04439C21.631 5.51039 21.423 5.00839 21.045 4.63039L19.459 3.04439C18.703 2.28839 17.384 2.29239 16.634 3.04139L7 12.5834L7 17.0134ZM18.045 4.45839L19.634 6.04139L18.037 7.62339L16.451 6.03839L18.045 4.45839ZM9 13.4174L15.03 7.44439L16.616 9.03039L10.587 15.0014L9 15.0064V13.4174Z"
                fill="#2B93E7"/>
          <path d="M5 21H19C20.103 21 21 20.103 21 19V10.332L19 12.332V19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.897 3 5V19C3 20.103 3.897 21 5 21Z"
                fill="#2B93E7"/>
        </svg>
        <span>Управление</span>
      </button>
    </div>
 
    <div v-if="form.note" class="comment">
      <div class="comment__info">{{ form.note }}</div>
    </div>

    <form class="form" @submit.prevent>
      <div class="form__content">
        <div class="form__part">
          <div class="form-group">
            <label>Региональная организация<sup>*</sup></label>
            <v-select
              v-model="form.region_org"
              :reduce="org => org.id"
              :filterable="false"
              :clearable="false"
              :options="region_options"
              :get-option-label="option => option.name"
              placeholder="Выберите региональную организацию"
              class="select"
              :class="{ 'select--error': $v.form.region_org.$error }"
              readonly
            >
              <template slot="open-indicator">
                <svg class="select__open-indicator" xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none">
                  <path clip-rule="evenodd" d="M10.06 17.25a7.19 7.19 0 100-14.38 7.19 7.19 0 000 14.38z"
                        stroke="#C7CFDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M20.12 20.12l-4.98-4.98" stroke="#C7CFDD" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
              </template>
              <template slot="no-options">Введите свой запрос для поиска</template>
              <template slot="option" slot-scope="option">
                <div class="select__item d-center">{{ option.name }} </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">{{ option.name }}</div>
              </template>
            </v-select>
            <div class="form-group__error" v-if="$v.form.region_org.$dirty && !$v.form.region_org.required">
              Обязательное поле
            </div>
          </div>

          <div class="form-group">
            <label for="number">Номер членского билета<sup>*</sup></label>
            <div class="form-control">
              <input
                id="number"
                type="number"
                min="0"
                max="999999"
                class="form-control__input"
                name="number"
                placeholder="Введите номер членского билета"
                v-model.number="form.number"
                :readonly="form.is_auto_number"
              />
            </div>
            <small v-if="form.number && String(form.number).length > 6" style="color: #ff9800;">
  Существующий номер содержит более 6 цифр.
</small>
          </div>

          <div class="form-group">
            <label for="lastname">Фамилия<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.lastname.$error }">
              <input
                id="lastname"
                type="text"
                class="form-control__input"
                name="lastname"
                placeholder="Иванов"
                v-model.trim="form.lastname"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.lastname.$dirty && !$v.form.lastname.required">Обязательное поле</div>
          </div>

          <div class="form-group">
            <label for="firstname">Имя<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.firstname.$error }">
              <input
                id="firstname"
                type="text"
                class="form-control__input"
                name="firstname"
                placeholder="Иван"
                v-model.trim="form.firstname"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.firstname.$dirty && !$v.form.firstname.required">Обязательное поле</div>
          </div>

          <div class="form-group">
            <label for="patronymic">Отчество</label>
            <div class="form-control">
              <input
                id="patronymic"
                type="text"
                class="form-control__input"
                name="patronymic"
                placeholder="Иванович"
                v-model.trim="form.patronymic"
              />
            </div>
          </div>

          <div class="form-group">
            <label for="dob">Дата рождения<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.dob.$error || $v.age.$error }">
              <masked-input
                v-model="form.dob"
                name="dob"
                mask="11.11.1111"
                placeholder="дд.мм.гггг"
                class="form-control__input"
                id="dob"
                autocomplete="off"
                @blur.native="onCheckBirth"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.dob.$dirty && !$v.form.dob.required">
              Обязательное поле
            </div>
            <div class="form-group__error" v-if="$v.form.dob.$dirty && !$v.age.minValue">
              Минимальный возраст для вступления: 14 лет
            </div>
            <div class="form-group__error" v-if="$v.form.dob.$dirty && !$v.age.maxValue">
              Максимальный возраст для вступления: {{ form.gender === 'Ж' ? 60 : 65 }} лет
            </div>
          </div>

          <div class="form-group">
  <label>Пол</label>
  <div class="form-group__party" :key="form.gender">
    <label class="radio">
      <div class="radio__text">Мужской</div>
      <input type="radio" name="gender" v-model="form.gender" value="М"/>
      <div class="radio__radiomark"></div>
    </label>
    <label class="radio">
      <div class="radio__text">Женский</div>
      <input type="radio" name="gender" v-model="form.gender" value="Ж"/>
      <div class="radio__radiomark"></div>
    </label>
  </div>
</div>
        </div>

        <div class="form__part">
          <div class="form-group">
            <label>Телефон</label>
            <vue-tel-input
              v-model="phone_value"
              defaultCountry="RU"
              mode="international"
              type="tel"
              class="phonepicker"
              :class="{ 'phonepicker--error': !is_phone_valid }"
              :inputOptions="phone_picker_options"
              validCharactersOnly
            >
              <template slot="arrow-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" fill="none">
                  <path d="M4.96 6.75L.23 1.47a.93.93 0 010-1.22.71.71 0 011.09 0L5.5 4.92 9.68.25a.71.71 0 011.1 0c.3.34.3.88 0 1.22L6.03 6.75A.73.73 0 015.5 7c-.2 0-.4-.08-.54-.25z"
                    fill="#2B93E7"></path>
                </svg>
              </template>
            </vue-tel-input>
            <div class="form-group__error" v-if="!is_phone_valid">Недопустимое значение для номера телефона</div>
          </div>

          <div class="form-group">
            <label for="email">Электронная почта</label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.email.$error }">
              <input
                id="email"
                type="email"
                name="email"
                class="form-control__input"
                placeholder="Введите электронную почту"
                v-model.trim="form.email"
                @change="$v.form.email.$touch()"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.email.$dirty && !$v.form.email.email">
              Введите правильный формат почты
            </div>
          </div>

          <div class="form-group">
            <label for="date_entry">Дата вступления<sup>*</sup></label>
            <div class="form-control" :class="{ 'form-control--error': $v.form.date_entry.$error }">
              <masked-input
                v-model="form.date_entry"
                name="date_entry"
                mask="11.11.1111"
                placeholder="дд.мм.гггг"
                class="form-control__input"
                id="date_entry"
                autocomplete="off"
                @blur.native="$v.form.date_entry.$touch"
              />
            </div>
            <div class="form-group__error" v-if="$v.form.date_entry.$dirty && !$v.form.date_entry.required">
              Обязательное поле
            </div>
            <div class="form-group__error" v-if="$v.form.date_entry.$dirty && !$v.form.date_entry.maxValue">
              Дата вступления, не может быть больше текущей даты
            </div>
          </div>

          <div class="form-group">
            <label>Домашний адрес</label>
            <!-- Контейнер для селекта и поля ввода -->
            <div class="address-input-wrapper">
              <!-- Поле ввода для ручного ввода или отображения выбранного адреса -->
              <input
                v-model="manualAddressInput"
                @input="onManualAddressInput"
                placeholder="Введите домашний адрес"
                class="form-control__input"
                :readonly="isAddressSelected" 
                
              />
              <!-- Кнопка для очистки выбора/перехода к ручному вводу -->
              <button
                v-if="isAddressSelected || manualAddressInput"
                @click="clearAddressSelection"
                type="button"
                class="address-clear-button"
                title="Очистить выбор / Ввести вручную"
              >
                &times; <!-- Или используйте SVG иконку -->
              </button>
            </div>

            <!-- Выпадающий список с вариантами (рендерится условно для экономии ресурсов) -->
            <div v-if="address_options.length > 0 && !isAddressSelected" class="address-suggestions">
              <div
                v-for="option in address_options"
                :key="option.id || option.address"
                @click="selectAddressFromList(option)"
                class="select__item d-center address-suggestion-item"
              >
                {{ option.address }}
              </div>
            </div>

            <!-- Скрытое поле или используем существующее form.address для хранения итогового значения -->
            <!-- В данном случае мы будем обновлять form.address напрямую в методах -->
            <!-- <input type="hidden" v-model="form.address" /> -->
          </div>

          <div class="form-group">
            <div class="form-group__place">
              <label class="checkbox">
                <div class="checkbox__text">Оплата членского взноса</div>
                <input type="checkbox" name="is_paid" v-model="form.is_paid" />
                <div class="checkbox__checkmark"></div>
              </label>
            </div>
          </div>

          <div class="form-group">
            <div class="form-group__place">
              <label class="checkbox">
                <div class="checkbox__text">Наличие согласия на обработку персональных данных</div>
                <input type="checkbox" name="has_agr_personal" v-model="form.has_agr_personal" />
                <div class="checkbox__checkmark"></div>
              </label>
            </div>
          </div>

          <div v-if="form.has_agr_parent" class="form-group">
            <div class="form-group__place">
              <label class="checkbox">
                <div class="checkbox__text">Наличие согласия на вступление от родителей</div>
                <input type="checkbox" name="has_agr_parent" v-model="form.has_agr_parent" />
                <div class="checkbox__checkmark"></div>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Блок наград -->
      <div class="form__part form__part--fullwidth">
        <div class="form-group">
          <label>Тип награды</label>
          <v-select
            v-model="selectedAwardType"
            :options="awardTypeOptions"
            label="name"
            placeholder="Выберите тип награды"
            class="select"
          />
        </div>

        <div class="form-group" v-if="selectedAwardType">
          <label>Награда</label>
          <v-select
            v-model="selectedAward"
            :options="filteredAwardsWithOther"
            :get-option-label="getAwardLabel"
            placeholder="Выберите награду"
            class="select"
          >
            <template slot="option" slot-scope="option">
              <div class="select__item d-center">
                {{ option.name }} 
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.name }} 
              </div>
            </template>
          </v-select>
        </div>

        <div class="form-group" v-if="isCustomAwardVisible">
          <label>Введите название награды вручную</label>
          <input
            v-model.trim="customAwardName"
            class="form-control__input"
            placeholder="Название награды"
          />
        </div>

        <div class="form-group" v-if="selectedAward">
          <label>Дата вручения<sup>*</sup></label>
          <masked-input
            v-model="customAwardDate"
            mask="11.1111"
            placeholder="мм.гггг"
            class="form-control__input"
          />
          <div class="form-group__error" v-if="$v.customAwardDate.$dirty && !$v.customAwardDate.validDate">
            Введите корректную дату в формате мм.гггг
          </div>
        </div>

        <div class="form-group">
          <label>Награды РО РСМ</label>
          <div class="awards-list">
            <div v-for="(award, index) in form.rewards_ro" :key="index" class="award-item">
              <span>{{ award.name }} </span>
              <span class="award-date">{{ formatDateForDisplay(award.date) }}</span>
              <button @click="removeAward(index, 'ro')" class="award-remove">Удалить</button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Награды РСМ</label>
          <div class="awards-list">
            <div v-for="(award, index) in form.rewards_rsm" :key="index" class="award-item">
              <span>{{ award.name }} </span>
              <span class="award-date">{{ formatDateForDisplay(award.date) }}</span>
              <button @click="removeAward(index, 'rsm')" class="award-remove">Удалить</button>
            </div>
          </div>
        </div>

        <div class="form-group" v-if="selectedAward">
          <button @click="addSelectedAward" class="button button--small">Добавить награду</button>
        </div>
      </div>

      <!-- Кнопка сохранить -->
      <div class="holder holder--end">
  <button
    @click="onCheckForm"
    class="button"
    type="submit"
  >
    <span>Сохранить изменения</span>
    <img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/>
  </button>
</div>
    </form>

    <SidebarManage
      :title="'Управление'"
      :class="{'sidebar-manage--full': show_sidebar}"
      @close-sidebar="show_sidebar = !show_sidebar"
    >
      <form>
        <div v-if="form.created_at" class="creation-date">
      <span class="creation-date__label">Дата создания карточки:</span>
      <span class="creation-date__value">{{ formatDate(form.created_at) }}</span>
    </div>
        <div class="form-group">
          <label for="comment_cancel">Примечание</label>
          <div class="form-control">
            <textarea
              @change="sendNote"
              id="comment_cancel"
              name="comment_cancel"
              class="form-control__textarea"
              v-model.trim="form.note"
              placeholder="Введите примечание"
            ></textarea>
          </div>
        </div>
      </form>
      <button
        v-if="form.status === 'warning'"
        @click="onContinue"
        class="button button--stretched button--indent-bottom"
        type="button"
      >
        Продлить учёт
      </button>
      <button
        @click="onRefuse"
        class="button button--stretched button--indent-bottom"
        type="button"
      >
        Прекратить учёт
      </button>
      <button
  @click="onDelete"
  class="button button--stretched button--indent-bottom button--danger"
  type="button"
>
  Удалить члена
</button>
    </SidebarManage>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minValue, maxValue } from 'vuelidate/lib/validators'
import SidebarManage from '@/components/SidebarManage'
import MaskedInput from 'vue-masked-input'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import { debounce } from "lodash"

export default {
  name: 'JournalEdit',
  mixins: [validationMixin],
  components: {
    SidebarManage,
    MaskedInput,
    VueTelInput
  },
  validations: {
    form: {
      number: { required },
      lastname: { required },
      firstname: { required },
      dob: { required },
      email: { email },
      date_entry: {
        required,
        maxValue: value =>
          new Date(`${value.slice(3, 5)}.${value.slice(0, 2)}.${value.slice(6)}`) <= new Date(),
      },
      region_org: { required }
    },
    age: {
      minValue: minValue(14),
      maxValue(value) {
        return this.form.gender === 'Ж' ? value <= 60 : value <= 65
      }
    },
    customAwardDate: {
    required,
    validDate(value) {
      const regex = /^(\d{2})\.(\d{4})$/
      if (!regex.test(value)) return false
      const [, month, year] = value.match(regex)
      return (
        +month >= 1 && +month <= 12 &&
        +year >= 1900 && +year <= new Date().getFullYear()
      )
    }
  }
  },
  data() {
    return {
      selectedAwardType: null,
      selectedAward: null,
      customAwardName: '',
      customAwardDate: '', // Теперь дата вручения вводится вручную
      awards: [],
      awardTypes: {},
      form: {
        status: 'active',
        rewards_ro: [],   // Уже есть
        rewards_rsm: [],  // Уже есть
        created_at: ''
      },
      phone_value: '',
      is_phone_valid: true,
      phone_picker_options: {
        placeholder: 'Введите номер телефона'
      },
      loading: false,
      region_options: [],
      local_options: [],
      address_detail: null,
      address_options: [],
      show_sidebar: false,
      manualAddressInput: '', // Для отслеживания ручного ввода
isAddressSelected: false, // Флаг, указывающий, был ли адрес выбран из списка
    }
  },
  computed: {
    userRole() {
      return this.$store.state.userRole
    },
    awardTypeOptions() {
      return Object.entries(this.awardTypes).map(([id, type]) => ({
        id,
        name: type.name
      }))
    },
    filteredAwardsWithOther() {
      if (!this.selectedAwardType) return []
      const filtered = this.awards.filter(award => award.type === this.selectedAwardType.id)
      return [
        ...filtered,
        { id: 'other', name: 'Другое', typeName: 'Неизвестный тип' }
      ]
    },
    isCustomAwardVisible() {
      return this.selectedAward?.id === 'other'
    }
  },
  mounted() {
    this.fetchForm()
    this.$store.dispatch('regOrg/GET_QUERY').then(response => {
      this.region_options = response.data
    })
    this.loadAwards()
  },
  methods: {
  getStatusLabel(status) {
    switch (status) {
      case 'active':
        return 'Активный'
      case 'warning':
        return 'Требует внимания'
      case 'disactive':
        return 'Снят с учета'
      default:
        return 'Неизвестный статус'
    }
  },
  limitMemberNumber() {
  // Если значение больше 999999, обрезаем его
  if (this.form.number > 999999) {
    this.form.number = parseInt(String(this.form.number).slice(0, 6), 10);
  }
},
    onManualAddressInput(event) {
      // Пользователь начал вводить адрес вручную
      // Сбрасываем флаг выбора из списка
      this.isAddressSelected = false;
      // Обновляем значение адреса в форме
      this.form.address = event.target.value;
      // this.form.address_json можно очистить или оставить пустым
      this.form.address_json = null; // или ''

      // Запускаем поиск (если нужно показывать предложения при вводе)
      const searchQuery = event.target.value.trim();
      if (searchQuery.length > 2) { // Начинаем поиск после 2+ символов
         this.performAddressSearch(searchQuery);
      } else {
          this.address_options = []; // Очищаем список, если мало символов
      }
    },
       formatDate(dateString) {
        console.log('📅 formatDate получила:', dateString, 'тип:', typeof dateString);
  if (!dateString) return '';

  // 1. Если уже в формате ДД.ММ.ГГГГ (возможно с временем) — берём только дату
  const match = String(dateString).match(/^(\d{2})\.(\d{2})\.(\d{4})/);
  if (match) {
    return `${match[1]}.${match[2]}.${match[3]}`;
  }

  // 2. Если ISO-формат (2026-08-03T14:30:00Z или 2026-08-03)
  try {
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
  } catch (e) {
    // игнорируем
  }

  // 3. Фоллбэк — возвращаем как есть
  return dateString;
},
    
    selectAddressFromList(option) {
      // Пользователь выбрал адрес из списка
      this.isAddressSelected = true;
      // Обновляем значение в поле ввода (оно будет заблокировано)
      this.manualAddressInput = option.address;
      // Обновляем значение адреса в форме
      this.form.address = option.address;
      // Сохраняем выбранный объект (если нужно)
      this.form.address_json = option; // или option.address, зависит от API
      // Очищаем список предложений
      this.address_options = [];
    },

    clearAddressSelection() {
       // Пользователь хочет очистить выбор или перейти к ручному вводу
       this.isAddressSelected = false;
       this.manualAddressInput = '';
       this.form.address = '';
       this.form.address_json = null; // или ''
       this.address_options = [];
    },

    // Модифицируем существующий метод onAddressSearch или создаем новый
    // для использования с ручным вводом
    performAddressSearch: debounce(function (query) {
       // Используем debounce из lodash, как у вас уже есть
       if (!query) {
          this.address_options = [];
          return;
       }
       this.$store.dispatch('FIND_ADDRESS', { search: query })
         .then(response => {
           // Убедимся, что список обновляется только если пользователь
           // не выбрал адрес пока шел запрос
           if (!this.isAddressSelected) {
              this.address_options = response.data || [];
           }
         })
         .catch(error => {
            console.error("Ошибка поиска адреса:", error);
            if (!this.isAddressSelected) {
               this.address_options = [];
            }
         });
    }, 350),
onDelete() {
  if (!confirm('Вы уверены, что хотите полностью удалить этого члена?')) return;

  this.$store.dispatch('journal/DELETE_MEMBER', { id: this.$route.params.id })
    .then(() => {
      this.$notify({ type: 'success', title: 'Успех!', text: 'Член успешно удален.' });
      this.$router.push({ name: 'journal-list' });
    })
    .catch(err => {
      console.error('Ошибка удаления:', err);
      this.$notify({ type: 'error', title: 'Ошибка!', text: 'Не удалось удалить члена.' });
    });
},
  fetchForm() {
    this.$store.dispatch('journal/GET_DATA', this.$route.params.id)
      .then(response => {
        this.form = {
          ...response.data,
          rewards_ro: response.data.rewards_ro || [],
          rewards_rsm: response.data.rewards_rsm || []
        };
        if (this.form.number && String(this.form.number).length > 6) {
        this.$notify({
          type: 'warn',
          title: 'Некорректный номер членского билета',
          text: 'Существующий номер содержит более 6 цифр и будет сохранён как есть.'
        });
      }
        this.phone_value = response.data.phone ?? '';
        if (response.data.address) {
            this.manualAddressInput = response.data.address;
            this.form.address = response.data.address;
            // Если был address_json, используем его для инициализации
             if (response.data.address_json) {
                 this.form.address_json = response.data.address_json;
                 this.isAddressSelected = true; // Считаем, что был выбран из списка
                 // Хотя это может быть не всегда верно, но логика такова:
                 // если есть address_json, значит был выбор
                 // Можно добавить флаг в API, если нужно точнее различать
             } else {
                 // Если есть только address, считаем ручным вводом
                 this.isAddressSelected = false;
                 this.form.address_json = null;
             }
          } else {
             this.manualAddressInput = '';
             this.form.address = '';
             this.form.address_json = null;
             this.isAddressSelected = false;
          }
        if (response.data.address_json) {
          this.address_detail = response.data.address_json;
        } else if (response.data.address) {
          this.address_detail = { address: response.data.address };
        }
        this.$store.dispatch('localOrg/GET_INREG_QUERY', {
          query: '',
          region_org: this.form.region_org
        }).then(res => {
          this.local_options = res.data;
        });
      })
      .catch(error => {
        this.loading = false;
        for (const key in error.response.data) {
          this.$notify({
            type: 'error',
            title: 'Ошибка!',
            text: typeof error.response.data[key] === 'string'
              ? error.response.data[key]
              : error.response.data[key][0]
          });
        }
      });
  },

  validateMonthYear(value) {
    const regex = /^(\d{2})\.(\d{4})$/
    if (!regex.test(value)) return false;
    const [, month, year] = value.match(regex);
    return (
      +month >= 1 &&
      +month <= 12 &&
      +year >= 1900 &&
      +year <= new Date().getFullYear()
    );
  },

  loadAwards() {
    const awardsData = [
      { model: "common.awardtype", pk: "ro", fields: { name: "Награды РО РСМ", sort: 10 } },
      { model: "common.awardtype", pk: "rsm", fields: { name: "Награды РСМ", sort: 20 } },
      { model: "common.award", pk: 1, fields: { name: "Благодарность Председателя РО РСМ", type: "ro", sort: 10 } },
      { model: "common.award", pk: 2, fields: { name: "Благодарность Председателя РСМ", type: "rsm", sort: 10 } },
      { model: "common.award", pk: 3, fields: { name: "Почетный диплом РСМ", type: "rsm", sort: 20 } },
      { model: "common.award", pk: 4, fields: { name: "Знак «За активную работу»", type: "rsm", sort: 30 } },
      { model: "common.award", pk: 5, fields: { name: "Знак «За заслуги» II степени", type: "rsm", sort: 40 } },
      { model: "common.award", pk: 6, fields: { name: "Знак «За заслуги» I степени", type: "rsm", sort: 50 } },
      { model: "common.award", pk: 7, fields: { name: "Знак «За поддержку деятельности РСМ»", type: "rsm", sort: 60 } },
      { model: "common.award", pk: 8, fields: { name: "Медаль РСМ «За вклад в работу с молодежью»", type: "rsm", sort: 70 } },
      { model: "common.award", pk: 9, fields: { name: "Почетное звание «Почетный член РСМ»", type: "rsm", sort: 80 } }
    ];

    this.awardTypes = {};
    this.awards = [];

    awardsData.forEach(item => {
      if (item.model === 'common.awardtype') {
        this.awardTypes[item.pk] = item.fields;
      } else if (item.model === 'common.award') {
        this.awards.push({
          id: item.pk,
          name: item.fields.name,
          type: item.fields.type,
          typeName: this.awardTypes[item.fields.type]?.name || 'Неизвестный тип',
          sort: item.fields.sort
        });
      }
    });

    this.awards.sort((a, b) => a.sort - b.sort);
  },

  addSelectedAward() {
  if (!this.selectedAward || !this.selectedAwardType) {
    this.$notify({ type: 'warn', title: 'Ошибка!', text: 'Выберите тип и награду' });
    return;
  }

  if (!this.validateMonthYear(this.customAwardDate)) {
    this.$notify({ type: 'warn', title: 'Ошибка!', text: 'Введите корректную дату в формате мм.гггг' });
    return;
  }

  let newAward = null;
  const typeName = this.awardTypes[this.selectedAwardType.id]?.name || 'Неизвестный тип';

  if (this.selectedAward.id === 'other') {
    if (!this.customAwardName.trim()) {
      this.$notify({ type: 'warn', title: 'Ошибка!', text: 'Введите название награды' });
      return;
    }
    
    const [month, year] = this.customAwardDate.split('.');
    const formattedDate = `${year}-${month.padStart(2, '0')}-01`;
    newAward = {
      id: Date.now(),
      name: this.customAwardName,
      type: this.selectedAwardType.id,
      typeName,
      date: formattedDate
    };
    this.customAwardName = '';
  } else {
    const [month, year] = this.customAwardDate.split('.');
    const formattedDate = `${year}-${month.padStart(2, '0')}-01`;
    newAward = {
      id: this.selectedAward.id,
      name: this.selectedAward.name,
      type: this.selectedAward.type,
      typeName: this.awardTypes[this.selectedAward.type]?.name || 'Неизвестный тип',
      date: formattedDate
    };
  }

  if (this.selectedAwardType.id === 'ro') {
    this.form.rewards_ro.push(newAward);
  } else {
    this.form.rewards_rsm.push(newAward);
  }

  this.selectedAward = null;
  this.customAwardDate = '';
},

  removeAward(index, type = 'ro') {
    if (type === 'ro') {
      this.form.rewards_ro.splice(index, 1);
    } else {
      this.form.rewards_rsm.splice(index, 1);
    }
  },

  onCheckForm() {
    console.log('Submitting form with gender:', this.form.gender); // Логируем текущее значение пола
    this.onCheckBirth();
    this.$v.form.$touch();

    if (this.$v.form.$invalid) {
      this.$notify({ type: 'warn', title: 'Внимание!', text: 'Проверьте заполненные поля формы.' });
      return;
    }

    const formatReward = reward => {
      let formattedDate = reward.date;

      // Преобразование формата даты YYYY-MM-DD в DD.MM.YYYY
      if (reward.date.includes('-')) {
        const [year, month, day] = reward.date.split('-');
        formattedDate = `${day}.${month}.${year}`;
      }

      return {
        name: reward.name,
        type: reward.type,
        date: formattedDate
      };
    };

    const data = {
      gender: this.form.gender, // добавляем поле gender
      number: this.form.number,
      lastname: this.form.lastname,
      firstname: this.form.firstname,
      patronymic: this.form.patronymic,
      dob: this.form.dob,
      email: this.form.email,
      date_entry: this.form.date_entry,
      address: this.form.address,
      has_agr_personal: this.form.has_agr_personal,
      has_agr_parent: this.form.has_agr_parent,
      is_paid: this.form.is_paid,
      rewards_ro: this.form.rewards_ro.map(formatReward),
      rewards_rsm: this.form.rewards_rsm.map(formatReward)
    };

    console.log("Отправляемые данные:", data);

    this.$store.dispatch('journal/PATCH_DATA', {
      id: this.$route.params.id,
      data
    }).then(() => {
      this.$notify({ type: 'success', title: 'Успех!', text: 'Данные сохранены.' });
      this.$router.push({ name: 'journal-list' });
    }).catch(err => {
      console.error('Ошибка отправки:', err);
      this.$notify({ type: 'error', title: 'Ошибка!', text: 'Не удалось сохранить данные' });
    });
  },

  getAwardLabel(option) {
  return option.name;
},

  setValues() {
    if (this.address_detail) {
      this.form.address_json = this.address_detail;
      this.form.address = this.address_detail.address;
    } else {
      this.form.address_json = '';
      this.form.address = '';
    }
  },

  onAddressSearch(search, loading) {
    loading(true);
    debounce((loading, search, vm) => {
      vm.$store.dispatch('FIND_ADDRESS', { search }).then(response => {
        vm.address_options = response.data;
        loading(false);
      });
    }, 350)(loading, search, this);
  },

  openSidebar() {
    this.show_sidebar = true;
  },

  onContinue() {
    this.$router.push({ name: 'journal-continue-create', query: { id: this.$route.params.id } });
  },

  onRefuse() {
    this.$router.push({ name: 'journal-refuse-create', query: { id: this.$route.params.id } });
  },

  onCheckBirth() {
    this.$v.form.dob.$touch();

    if (!this.form.dob || !this.validateDate(this.form.dob)) {
      this.age = 0;
      return;
    }

    const [day, month, year] = this.form.dob.split('.');
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();

    this.age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      this.age--;
    }
  },

  validateDate(dateString) {
    const regex = /^(\d{2})\.(\d{2})\.(\d{4})$/
    if (!regex.test(dateString)) return false;
    const [, day, month, year] = dateString.match(regex);
    const date = new Date(year, month - 1, day);
    return (
      date.toString() !== 'Invalid Date' &&
      String(date.getDate()).padStart(2, '0') === day &&
      String(date.getMonth() + 1).padStart(2, '0') === month &&
      String(date.getFullYear()) === year
    )
  },

  formatDateForDisplay(isoDate) {
  if (!isoDate) return '';

  let year, month;

  // Если формат YYYY-MM-DD
  if (isoDate.includes('-')) {
    [year, month] = isoDate.split('-');
  } else if (isoDate.includes('.')) {
    // Если формат DD.MM.YYYY
    const parts = isoDate.split('.');
    year = parts[2];
    month = parts[1];
  }

  const monthNames = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
},
mounted() {
  this.fetchForm();
  this.loadAwards();
},
getMonthName(monthNumber) {
  const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];
  return months[parseInt(monthNumber, 10) - 1] || 'Неизвестный месяц';
}, 

  sendNote() {
    this.$store.dispatch('journal/PATCH_DATA', {
      id: this.$route.params.id,
      data: { note: this.form.note }
    }).then(() => {
      this.$notify({ type: 'success', title: 'Успех!', text: 'Примечание изменено.' });
    }).catch(() => {
      this.$notify({ type: 'error', title: 'Ошибка!', text: 'Ошибка изменения примечания.' });
    });
  },

  /**
   * Метод для принудительного обновления компонента (рекомендуемое решение).
   */
  updateGender() {
    console.log('Current gender:', this.form.gender);
  },

  updated() {
    this.updateGender(); // Обновляем значение пола каждый раз при рендеринге.
  }
}
}
</script>

<style scoped>
.awards-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.award-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9f9f9;
  padding: 10px 16px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
}

.award-item:hover {
  background-color: #f0f0f0;
}

.award-name {
  font-weight: 500;
  color: #333;
}

.award-date {
  margin-left: auto;
  margin-right: 16px;
  font-size: 14px;
  color: #777;
}

.award-remove {
  background-color: transparent;
  border: none;
  color: #e53935;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.award-remove:hover {
  opacity: 0.8;
}

/* Стили для виджета статуса */
.status-widget {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}

.status-widget--active {
  background-color: #4caf50; /* Зеленый для активного статуса */
}

.status-widget--warning {
  background-color: #ff9800; /* Оранжевый для статуса "требует внимания" */
}

.status-widget--disactive {
  background-color: #f44336; /* Красный для статуса "снят с учета" */}

  .button--danger {
  background-color: #e53935;
  color: white;
}
.button--danger:hover {
  background-color: #c62828;
}
.address-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.address-input-wrapper .form-control__input {
  flex-grow: 1;
  /* Добавим немного отступа справа для кнопки */
  padding-right: 30px; /* Ширина кнопки + отступ */
}

.address-clear-button {
  position: absolute;
  right: 5px; /* Отступ от правого края */
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.address-clear-button:hover {
  color: #333;
}

.address-suggestions {
  position: absolute;
  top: 100%; /* Располагаем под полем ввода */
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-top: none; /* Убираем верхнюю границу, чтобы соединить с input */
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000; /* Поверх других элементов */
  max-height: 200px;
  overflow-y: auto;
  margin-top: -1px; /* Компенсируем толщину border-top input */
}

.address-suggestion-item {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.address-suggestion-item:hover {
  background-color: #f5f5f5;
}

.address-suggestion-item:last-child {
   border-bottom: none;
}
/* Также нужно скорректировать position родительского .form-group,
   чтобы absolute позиционирование .address-suggestions работало корректно */
.form-group {
  position: relative; /* Добавляем это, если еще не установлено */
}
</style>